import { createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Marks a widget subtree where drill-down navigation must be disabled.
 *
 * Set to true on per-customer (Tenant-type) dashboards: there the partner is
 * authenticated in their own tenant while only the data is customer-scoped via
 * the customerid header, so a relative route drill-down would resolve in the
 * partner's own tenant and show the wrong data.
 */
export const WidgetDrillDownContext = createContext<boolean>(false);

export function useWidgetDrillDownDisabled(): boolean {
  return useContext(WidgetDrillDownContext);
}

/**
 * Returns a navigate callback for widget drill-downs.
 * No-ops when drill-down is disabled, otherwise pushes the route.
 */
export function useWidgetDrillDownNavigate(): (url: string) => void {
  const disabled = useContext(WidgetDrillDownContext);
  const history = useHistory();

  return (url: string) => {
    if (disabled) {
      return;
    }

    history.push(url);
  };
}
